var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_logo"},[_c('div',{staticClass:"circle",on:{"click":_vm.go_top}},[_c('img',{attrs:{"src":"/img/menu_logo.png"}})]),_c('img',{staticClass:"sp_logo",attrs:{"src":"/img/sp_logo.png"},on:{"click":_vm.go_top}})])}
var staticRenderFns = []

export { render, staticRenderFns }